import { NgClass, UpperCasePipe } from '@angular/common';
import { AfterContentChecked, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { fade } from '@common/animations/fade';
import { ButtonComponent } from '@common/components/button/button.component';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { User } from '@common/models/user';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DropDownButtonComponent } from '@progress/kendo-angular-buttons';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DialogService } from '@services/dialog.service';
import { I18nService } from '@services/i18n.service';
import { QueryService } from '@services/query.service';

@Component({
    selector: 'app-sidebar-profile',
    templateUrl: './sidebar-profile.component.html',
    animations: [fade],
    imports: [
        ButtonComponent,
        NgClass,
        TranslatePipe,
        TooltipDirective,
        DropDownButtonComponent,
        UpperCasePipe,
        RouterLink,
        NgIcon
    ]
})
export class SidebarProfileComponent implements AfterContentChecked {
    @Output() togglePinSidebar = new EventEmitter();
    @Output() toggleTheme = new EventEmitter();
    @Output() uploadImage = new EventEmitter();
    @Input() isSidebarExpanded: boolean;
    @Input() isSidebarPinned: boolean;
    @Input() currentUser: User;
    @Input() darkTheme: boolean;
    languageFlag = false;
    private i18nService = inject(I18nService);
    languages = this.i18nService.languages;
    currentLanguage = this.i18nService.currentLanguage;
    private dialogService = inject(DialogService);
    private translateService = inject(TranslateService);
    private router = inject(Router);
    private queryService = inject(QueryService);

    ngAfterContentChecked(): void {
        this.getLanguageFlagValue();
    }

    logout() {
        this.dialogService
            .confirm({
                options: {
                    title: this.translateService.instant('Sign Out') as string,
                    titleIcons: ['faSolidArrowRightFromBracket'],
                    message: this.translateService.instant('Are you sure you want to sign out?') as string
                }
            })
            .then((result) => {
                if (result === true) {
                    this.router.navigate(['/logout']);
                }
            });
    }

    navigateToUserSettings = () => this.router.navigate(['/user-settings']);
    navigateToUserProfile = () => this.router.navigate(['/user-account/view', this.currentUser.id]);

    private getLanguageFlagValue() {
        const settings = this.queryService.queryClient.getQueryData<Setting[]>(['settings']);
        if (settings) {
            const languageFlagSetting = settings?.find((s: Setting) => s.key === SettingKeyCodes.LanguageFlag);
            if (languageFlagSetting) this.languageFlag = languageFlagSetting.value === 'true';
        }
    }
}
